import _ from 'underscore';
import RouteModel from './RailwayRouteModelv2';

type TsorkBykey = 'fullPrice';

export default class RailwayRoutesModel {
    private _routesModels: RouteModel[];

    constructor(routes: RouteModel[]) {
        this._routesModels = routes;
    }

    value(): RouteModel[] {
        return this._routesModels;
    }

    sortBy(key: TsorkBykey = 'fullPrice'): RailwayRoutesModel {
        const sortedRoutes = _.sortBy(this._routesModels, (route) => route[key]);
        return new RailwayRoutesModel(sortedRoutes);
    }

    getUniqRoutes(): RailwayRoutesModel {
        const uniqRoutes = _.uniq(this._routesModels, (routeModel) => routeModel?.pk);

        return new RailwayRoutesModel(uniqRoutes);
    }
}
